module.exports = __webpack_public_path__ + "static/media/task-warning-big-icon.e1319d46.svg";